import React, { useState } from 'react';
import MailIcon from 'assets/icons/mail.svg';
import { ButtonType, Button, notification, Modal, Input } from 'syngenta-digital-cropwise-react-ui-kit';
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { RBAC_ACTIONS } from 'services/rbacActions';
import { history, RoutePaths } from 'core/history';
import { translationWrapper } from 'utils/common-methods';

export const WorkspaceCreateEditModal = (props: any) => {
    const { t } = translationWrapper(useTranslation());
    const { workspaceData = {}, callBack = () => false, deleteWorkspace, editWorkspace, setIsEditWorkSpace, deleteModalVisible, setDeleteModalVisible, createWorkspace } = props;
    const [loading, setLoading] = useState<any>({});
    const [wsName, setWsName] = useState(workspaceData.name);
    if (!workspaceData.id) {
        workspaceData.rbacPermissions = {
            [RBAC_ACTIONS.workspace.delete]: true,
            [RBAC_ACTIONS.workspace.write]: true,
        }
    }

    const onDelete = async () => {
        let deleteResponse;
        setLoading({ edit: false, delete: true });
        try {
            deleteResponse = await deleteWorkspace(workspaceData.id);
            notification.success({
                message: t('global.edit_workspace_modal.notification.successfully_deleted'),
                description: t('global.edit_workspace_modal.notification.workspace_deleted_with_success'),
                placement: 'topRight',
            });
            history.push({
                pathname: RoutePaths.OVERVIEW(),
                search: location.search
            });
        } catch (e) {
            notification.error({
                message: t('global.edit_workspace_modal.notification.failed_to_deleted_workspace'),
                description: t('global.edit_workspace_modal.notification.the_deleted_request_failed_try_again'),
                placement: 'topRight',
            });
        }
        setLoading({})
        callBack({ type: 'delete', data: deleteResponse })
    };

    const onSave = async () => {
        if (workspaceData.id) {
            setLoading({ edit: true, delete: false });
            const workspaceEdited = Object.assign({}, workspaceData, { name: wsName });
            let editedResponse;
            try {
                editedResponse = await editWorkspace(workspaceEdited);
                notification.success({
                    message: t(`global.edit_workspace_modal.notification.the_workspace_name_was_successfully_edited`),
                    description: t(`global.edit_workspace_modal.notification.your_workspace_name_is`, { workSpaceName: wsName } ),
                    placement: 'topRight',
                });
            } catch (e) {
                notification.error({
                    message: t(`global.edit_workspace_modal.notification.the_workspace_name_was_failed_to_edit`),
                    description: t(`global.edit_workspace_modal.notification.your_workspace_name_is`, { workSpaceName: workspaceData.name }),
                    placement: 'topRight',
                });
            }
            callBack({ type: 'edit', data: editedResponse });
            setLoading({});
        } else {
            let createResponse;
            setLoading({ edit: false, delete: false, create: true });
            try {
                createResponse = await createWorkspace({ name: wsName });
                notification.success({
                    message: t('global.edit_workspace_modal.notification.successfully_created'),
                    description: t('global.edit_workspace_modal.notification.workspace_created_with_success'),
                    placement: 'topRight',
                });
            } catch (e) {
                notification.error({
                    message: t('global.edit_workspace_modal.notification.failed_to_create_workspace'),
                    description: t('global.edit_workspace_modal.notification.the_create_request_failed_try_again'),
                    placement: 'topRight',
                });
            }
            callBack({ type: 'create', data: createResponse });
            setLoading({});
        }
    };

    return <>
        <Modal
            title={<div><img src={MailIcon}></img>
                <span className='title'>
                    {t(workspaceData.id ? 'global.edit_workspace_modal.title.edit_workspace_name' : 'global.edit_workspace_modal.title.create_workspace_name')}
                </span>
            </div>}
            visible={workspaceData}
            onOk={() => false}
            onCancel={() => { setIsEditWorkSpace('') }}
            width="455px"
            className='workspace-add-edit-modal'
            footer={[
                <div key='edit-workspace-footer' className='edit-workspace-footer-main-container'>
                     <div className='workspace-delete-div'>
                        {
                workspaceData.id ?
                    <Button loading={loading.delete} disabled={!workspaceData.rbacPermissions[RBAC_ACTIONS.workspace.delete]} className='remove-workspace-button' onClick={() => { setDeleteModalVisible(true) }} key="back" icon={<DeleteOutlined></DeleteOutlined>}>
                        {t('global.edit_workspace_modal.button.remove_workspace')}
                    </Button> : <></>
            }
                  </div>
                  <div className='workspace-save-cancle-div'>
                <Button className='workspace-cancel-button' key="submit" onClick={() => { setIsEditWorkSpace('') }}>
                    {t('global.button.cancel')}
                </Button>
                <Button
                    className='workspace-save-button'
                    type={ButtonType.primary}                
                    loading={loading.edit || loading.create}
                    disabled={!workspaceData.rbacPermissions[RBAC_ACTIONS.workspace.write]}
                    onClick={() => {
                        onSave()
                    }}
                >
                    {t('global.button.save')}
                </Button>
                </div>
            </div>
            ]}
        >
            <div className="modal-placeholder">
                <p>
                    {t('global.edit_workspace_modal.text.workspace_is_where_all_your_organizations')}
                </p>
                <div className="workspace-modal-form">
                    <label htmlFor="">{t('global.edit_workspace_modal.text.workspace_name')}</label>
                    <Input placeholder={t('global.edit_workspace_modal.text.name_of_your_workspace')}
                        value={wsName}
                        onChange={(e) => setWsName(e.target.value)}
                    />
                    <div className='form-input-sample'> Ex. "Agro Ltd."</div>
                </div>

            </div>
        </Modal>
        {
            (workspaceData.id && deleteModalVisible) ? <DeleteModalWarning
                onDelete={onDelete}
                setDeleteModalVisible={setDeleteModalVisible}
                deleteModalVisible={deleteModalVisible}></DeleteModalWarning> : null
        }

    </>
}


export const DeleteModalWarning = (props: any) => {
    const { deleteModalVisible, onDelete, setDeleteModalVisible } = props;
    const { t } = translationWrapper(useTranslation());
    return <Modal
        visible={deleteModalVisible}
        okText={t('global.button.delete')}
        okButtonProps={{ danger: true }}
        cancelText={t('global.button.cancel')}
        cancelButtonProps={{ className: 'cancel-button' }}
        onCancel={() => setDeleteModalVisible(false)}
        onOk={() => { setDeleteModalVisible(''); onDelete() }}
        className="warning-modal-container workspace-delete-modal"
        centered={true}
        closable={false}
    >
        <div className="workspace-modal__inner">
            <div><InfoCircleOutlined className='title-icon'></InfoCircleOutlined>
                <span className='title'>
                    {t('global.edit_workspace_modal.text.do_you_want_to_delete_the_workspace')}
                </span>
            </div>
            <div className='content'>
                <span className="workspace-modal__inner__text">
                    {t('global.edit_workspace_modal.text.this_cannot_be_undone_you_will_lose_its_organizations')}
                </span>

            </div>
        </div>
    </Modal>
}